// src/components/PopupPictureUpload.js
import React, { useState } from "react";
import "./PopupPictureUpload.css";

const PopupPictureUpload = () => {
  const [imageData, setImageData] = useState(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      // Update local state (for immediate preview)
      setImageData(result);
      // Send the image to the server
      fetch(`${process.env.REACT_APP_API_URL}/api/popupImage`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ imageData: result }),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("Image uploaded successfully:", data);
          // Optionally, update state with the data returned by the backend
          setImageData(data.imageData);
        })
        .catch((error) =>
          console.error("Error uploading image to server:", error)
        );
    };
    reader.readAsDataURL(file);
  };

  const handleDeleteImage = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/popupImage`, {
      method: "DELETE",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Image deleted:", data);
        setImageData(null);
      })
      .catch((error) =>
        console.error("Error deleting image from server:", error)
      );
  };

  return (
    <div className="popup-picture-upload-container">
      <div className="upload-controls">
        <input type="file" accept="image/*" onChange={handleImageUpload} />
        {imageData && (
          <button onClick={handleDeleteImage}>Delete Picture</button>
        )}
      </div>
    </div>
  );
};

export default PopupPictureUpload;
